export const ApiPaths = {
  Supplier: {
    CreateDoc: `/Supplier/SaveDocs`,
    CreateDocuments: `/Supplier/SaveDocuments`,
    LookUpData: `/Supplier/GetLookups`,
    SaveContactsWithoutLogin: `/Supplier/SaveContactsWithoutLogin`,
    SaveContactsWithLogin: `/Supplier/SaveContactsWithLogin`,
    SaveCompanyInfo: `/Supplier/SaveCompanyInfo`,
    Search: `/Supplier/Search`,
    GetAllSupplierListBySerach:'Supplier/GetAllSupplierListBySerach',
    GetHomeListBySerach:'Supplier/GetHomeListBySerach',
    ChangeStatus: `/Supplier/Status`,
    JobAllotmentStatus: `/Supplier/JobAllotmentStatus`,
    Save: `/Supplier/Save`,
    SaveProfileAddress: `/Supplier/ProfileAddress`,
    SaveSocialLink: `/Supplier/SocialLink`,
    SearchJobAllotmentSupplier: `/JobRequest/SearchSuppliers`,
    JobSupplierAllotment: `/Supplier/JobSupplierAllotment`,
    Upload: `/Supplier/Upload`,
    GetImage: `/Supplier/GetImage`,
    GetAllImages: `/Supplier/GetAllImages`,
    UnAssignSupplier: `/Supplier/UnAssignSupplier`,
    GetSupplierLinkEpData: `/Supplier/GetSupplieLinkedClient`,
    GetSupplierData: (supplierId: number) => `/Supplier/GetSupplierDocs/${supplierId}`,
    GetSupplierDocData: (supplierId: number) => `/Supplier/GetSupplierDocuments/${supplierId}`,
    GetSupplierDocDataWithoutAuth: (supplierId: string) => `/Supplier/GetSupplierDocumentsWithoutAuth/${supplierId}`,
    GetSupplierInfo: (supplierId: number) => `/Supplier/GetSupplierInfo/${supplierId}`,
    DeleteSuppContact: (contactId: number) => `/Supplier/DeleteSuppContact/${contactId}`,
    DeleteContact: (contactId: number) => `/Supplier/DeleteContact/${contactId}`,
    LoadAllState: (countryId: number) => `/State/${countryId}`,
    GetSupplier: (supplierId: number) => `/Supplier/${supplierId}`,
    GetSupplierInf: (supplierId: number) => `/Supplier/Info/${supplierId}`,
    GetSupplierBriefInfo: (supplierId: number) => `/Supplier/GetBriefInfo/${supplierId}`,
    SupplierDetail: (supplierId: number) => `/Supplier/Detail/${supplierId}`,
    SupplierApprove: (userId: number) => `/Supplier/Approve/${userId}`,
    MapSupplierToDiffClient: (emailId: string) => `/Supplier/MapSupplierToClient/${emailId}`,
    SupplierGetLookUp: (clientId: number) => `/Supplier/GetLookUp/${clientId}`,
    CheckSupplierEmail: `/Supplier/ValidateProfile`,
    GetJobDetailsByJobId: (jobid: number) => `/JobRequest/GetShortInfo/${jobid}`,
    GetSuppContacts: (supplierId: number) => `/Supplier/GetSuppContacts/${supplierId}`,
    GetContacts: (supplierId: number) => `/Supplier/GetContacts/${supplierId}`,
    GetCategoriesList: `/Supplier/GetCategoriesList`,
    GetCategories: (isAll: boolean) => `/Supplier/GetCategories/${isAll}`,

    GetSecCategories: `/Supplier/GetSecCat`,
    SaveCategories: `/Supplier/SaveCategories`,
    GetSuplierDocumentsType:(Id: any) => `/Supplier/GetDocumentsTypeWithoutAuth/${Id}`,
    GetSupplierDocumentsData: (supplierId: number) => `/Supplier/GetUploadedDocWithoutAuth/${supplierId}`,
    SaveUploadedDocsWithoutAuth: `/Supplier/SaveUploadedDocsWithoutAuth`,

    GetSuplierDocTypeList:(Id: any) => `/Supplier/GetDocumentsType/${Id}`,
    getSupplierUploadedDocData: (supplierId: number) => `/Supplier/GetUploadedDoc/${supplierId}`,
    addUploadedDocuments: `/Supplier/SaveUploadedDocs`,

    GetQuestionList:`/Questionnaires/GetAllQuestionnaires`,

  },
};
